import {
  OutcomeAnalysisRequest,
  OutcomeTrackerHeadlinesResponse,
  PostOutcomeTrackerHeadlinesResponse,
} from '../../api-models/types.gen';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface, OutcomeTrackerHeadlines } from '../../types/global';
import { getCustomIcon } from '../../utils/icons';

import BaseAdapter from './baseAdapter';
import { adaptBackendFilters } from '../../utils/filters';
import outcomeTrackerAdaptRequest, { OutcomeTrackerAdaptRequestProps } from './outcomeTrackerAdaptRequest';

export default class PostOutcomeTrackerHeadlines extends BaseAdapter<OutcomeTrackerHeadlinesResponse> implements AdapterInterface {
  rawResponse: PostOutcomeTrackerHeadlinesResponse;

  modifiedRequest: OutcomeAnalysisRequest;

  async adaptResponse(request: OutcomeTrackerAdaptRequestProps): Promise<OutcomeTrackerHeadlines> {
    const formattedRequest = this.adaptRequest(request);
    await this.fetchApiResponse('/api/outcome-tracker/headlines', HTTPMethod.Post, formattedRequest);
    const { cards, positive_outcome: positiveOutcome, summary } = this.rawResponse;
    return {
      summary: {
        filters: adaptBackendFilters(summary.filters),
        analysisName: summary.analysis_name,
        numberOfHouseholdsTargeted: summary.number_of_households_start,
        numberOfHouseholdsStillInData: summary.number_of_households_end,
        start: summary.start,
        end: summary.end,
      },
      cards: cards.map((outcomeTrackerCardResponse) => ({
        icon: getCustomIcon(outcomeTrackerCardResponse.icon),
        text: outcomeTrackerCardResponse.title,
        tooltip: outcomeTrackerCardResponse.tooltip,
        displayNumber: outcomeTrackerCardResponse.value,
        trendUpward: outcomeTrackerCardResponse.trend_upward,
        footer: outcomeTrackerCardResponse.description,
      })),
      positiveOutcome: {
        icon: getCustomIcon(positiveOutcome.icon),
        title: positiveOutcome.title,
        tooltip: positiveOutcome.tooltip,
        displayValue: positiveOutcome.value,
        unit: positiveOutcome.unit,
        valueSubtitle: positiveOutcome.description,
        barChartData: positiveOutcome.bar_chart.map((barChartDatum) => ({
          label: barChartDatum.category_label,
          dataLabel: barChartDatum.data_label,
          percentage: barChartDatum.percentage_of_total_households,
          color: barChartDatum.colour,
        })),
        pieChartData: {
          greenValue: positiveOutcome.pie_chart.percentage,
          greyValue: 100 - positiveOutcome.pie_chart.percentage,
          label: positiveOutcome.pie_chart.label,
        },
      },
    };
  }

  adaptRequest(request: OutcomeTrackerAdaptRequestProps): OutcomeAnalysisRequest {
    this.modifiedRequest = outcomeTrackerAdaptRequest(request);
    return this.modifiedRequest;
  }
}
